<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="625"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          {{ form.id === '' ? 'Tambah' : 'Ubah' }} <span v-if="name_parent !== '' && form.id === ''" class="pl-2">Sub di {{ name_parent }}</span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <v-form>
              <ValidationProvider 
                name="code" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Kode
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  
                  placeholder="Contoh. 001"

                  v-model="form.number"
                  :success="form.number !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Kode {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.number !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="Nama Kriteria" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nama Kriteria
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. PERENCANAAN STRATEGIS"

                  v-model="form.kriteria"
                  :success="form.kriteria !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 100%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nama Kriteria {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.kriteria !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <div v-if="is_last">
                <ValidationProvider 
                  name="Bobot Minor" 
                  rules="required|min_0:0" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    Bobot Minor
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </div>

                  <v-currency-field
                    filled
                    rounded
                    dense
                    :color="set_color"
                    hide-details
                    placeholder="Contoh. 10"

                    v-model="form.bobot_minor"
                    :success="form.bobot_minor !== '' && valid"
                    :error-messages="errors"
                    class="mb-6"
                    style="border-radius: 10px; width: 70%;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Bobot Minor {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form.bobot_minor !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-currency-field>
                </ValidationProvider>

                <ValidationProvider 
                  name="Bobot Mayor" 
                  rules="required|min_0:0" 
                  v-slot="{ errors, valid }">
                  <div class="body-2 mb-2">
                    <span class="red--text">*</span>
                    Bobot Mayor
                    <span class="error--text">
                      (wajib diisi)
                    </span>
                  </div>

                  <v-currency-field
                    filled
                    rounded
                    dense
                    :color="set_color"
                    hide-details
                    placeholder="Contoh. 10"

                    v-model="form.bobot_mayor"
                    :success="form.bobot_mayor !== '' && valid"
                    :error-messages="errors"
                    class="mb-6"
                    style="border-radius: 10px; width: 70%;">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          Bobot Mayor {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="form.bobot_mayor !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-currency-field>
                </ValidationProvider>
              </div>
            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hapus Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat 
          style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row>
              <v-col 
                cols="12" 
                md="8" 
                class="d-flex align-center">
                <div class="mr-3">
                  <v-btn
                    elevation="0"
                    style="background: #4caf5033; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center green--text"
                    @click="dialog.form = true; reset();">
                    <v-icon size="18">mdi-plus-circle-outline</v-icon>

                    <span class="ml-1">
                      Tambah
                    </span>
                  </v-btn>
                </div>

                <!-- <div v-if="selected.row.length === 1"
                  class="mr-3" >
                  <v-btn 
                    elevation="0"
                    style="background: #2196f333; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                    @click="dialog.form = true; reset(selected.row[0]);">
                    <v-icon size="18">mdi-circle-edit-outline</v-icon>

                    <span class="ml-1">
                      Ubah
                    </span>
                  </v-btn>
                </div>

                <div v-if="selected.row.length > 0"
                  class="mr-3" >
                  <v-btn
                    elevation="0"
                    style="background: #f4403433; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center red--text"
                    @click="toDelete()">
                    <v-icon size="18">mdi-delete-circle-outline</v-icon>

                    <span class="ml-1">
                      Hapus
                    </span>
                  </v-btn>
                </div> -->
              </v-col>
                
              <v-col 
                cols="12" 
                md="4" 
                class="d-flex align-center justify-end">
                <v-text-field
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  placeholder="Cari . . ."
                  vvvv-uppercase
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search"
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  style="border-radius: 10px;">
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>


          <v-card-text
            v-if="process.load" 
            class="pb-0 my-4" 
            style="height: calc(100vh - 276px); display: flex; align-items: center; justify-content: center;">
            <div class="text-center">
              <div class="mb-4 title">
                Mohon Tunggu . . .
              </div>

              <v-progress-linear
                :color="set_color"
                indeterminate
                rounded
                height="10">
              </v-progress-linear>
            </div>
          </v-card-text>

          <div class="view" v-if="!process.load">
            <table style="width: 100%;">
              <tr>
                <td class="px-5 fs-12 font-weight-bold white--text py-1" style="min-width: 200px;" :style="`background-color: ${set_color};`">
                  Kode
                </td>
                <td class="text-left px-4 pl-3 py-1 fs-12 font-weight-bold white--text" style="width: 590px; min-width: 590px;" :style="`background-color: ${set_color};`">
                  <!-- border: 1px solid #eee; border-top: 0px; border-bottom: 0px; -->
                  Nama
                </td>
                <td class="text-left px-4 py-1 fs-12 pl-0 font-weight-bold white--text" style="width: 150px; max-width: 150px; min-width: 150px;" :style="`background-color: ${set_color};`">
                  Bobot Minor
                </td>
                <td class="text-left px-4 py-1 fs-12 pl-0 font-weight-bold white--text" style="width: 150px; max-width: 150px; min-width: 150px;" :style="`background-color: ${set_color};`">
                  Bobot Mayor
                </td>
              </tr>
            </table>

            <v-treeview
              v-model="tree"
              :items="list"
              item-key="id"
              activatable
              item-children="child"
              item-text="test"
              class="border_buttom_tree fs-12"
            >
              <template v-slot:prepend="{ item }">
                <div class="d-flex">
                  <v-tooltip 
                    top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="reset(item); dialog.form = true;"
                        
                        v-bind="attrs"
                        v-on="on"
  
                        min-width="20"
                        min-height="20"
                        x-small
                        rounded
                        color="blue"
                        elevation="0"
                        class="white--text text-capitalize mx-1 px-0"
                        style="font-weight: 600; border-radius: 6px;">
                        <v-icon size="12">mdi-square-edit-outline</v-icon>
                      </v-btn>
                    </template>
  
                    <span>Ubah</span>
                  </v-tooltip>
                  <v-tooltip 
                    top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        min-width="20"
                        min-height="20"
                        x-small
                        rounded
                        :disabled="item.child === undefined ? true : false"
                        @click="dialog.form = true; resetSub(item);"
                        color="green"
                        elevation="0"
                        class="white--text text-capitalize mx-1 px-0"
                        style="font-weight: 600; border-radius: 6px;">
                        <v-icon size="12">mdi-plus-circle</v-icon>
                        
                      </v-btn>
                    </template>
  
                    <span>Tambah</span>
                  </v-tooltip>
                  <v-tooltip 
                    top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="toDelete(item.id)"
  
                        v-bind="attrs"
                        v-on="on"
  
                        min-width="20"
                        min-height="20"
                        x-small
                        :disabled="item.child !== undefined && item.child.length > 0 ? true : false"
                        rounded
                        color="red"
                        elevation="0"
                        class="white--text text-capitalize mx-1 px-0"
                        style="font-weight: 600; border-radius: 6px;">
                        <v-icon size="12">mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    
                    <span>Hapus</span>
                  </v-tooltip>
                  <div :class="item.par_id === '0' && item.child !== undefined ? 'font_weight_600 fs-12' : item.par_id !== '0' && item.child !== undefined ? 'font_weight_600 fs-11' : ''">
                    {{ item.number }}
                  </div>
                  <!-- <div :class="item.par_id === '0' && item.child !== undefined ? 'font_weight_600 fs-12' : ''">
                    {{ item.kriteria }}
                  </div> -->
                </div>
              </template>
              <template v-slot:append="{ item }">
                <div class="d-flex">
                  <div style="min-width: 590px; max-width: 590px; padding-left: 20px;" :class="item.par_id === '0' && item.child !== undefined ? 'font_weight_600 fs-12' : item.par_id !== '0' && item.child !== undefined ? 'font_weight_600 fs-11' : 'fs-11'">
                    {{ item.kriteria }}
                  </div>
                  <div style="min-width: 150px; padding-left: 70px;" calss="text-capitalize" :class="item.par_id === '0' && item.child !== undefined ? 'font_weight_600 fs-12' : item.par_id !== '0' && item.child !== undefined ? 'font_weight_600 fs-11' : 'fs-11'">
                    {{ item.bobot_minor === '' || item.bobot_minor === null ? '-' : item.bobot_minor }}
                  </div>
                  <div style="min-width: 150px; padding-left: 70px;" calss="text-capitalize" :class="item.par_id === '0' && item.child !== undefined ? 'font_weight_600 fs-12' : item.par_id !== '0' && item.child !== undefined ? 'font_weight_600 fs-11' : 'fs-11'">
                    {{ item.bobot_mayor === '' || item.bobot_mayor === null ? '-' : item.bobot_mayor }}
                  </div>
                </div>
              </template>
            </v-treeview>
            <!-- <div :class="list.length < 1 ? '' : 'wrapper_internal'">
              <table style="border: 1px solid #ededed; width: 100%;" class="table">
                <tr>
                  <th class="sticky-col one-col" style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 120px; min-width: 120px; max-width: 120px;" :style="`background-color: ${set_color};`">Aksi</th>
                  <th class="sticky-col second-col" style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 280px; min-width: 280px; max-width: 280px;" :style="`background-color: ${set_color};`">Nama</th>
                </tr>
                <tr v-for="(item, index) in list" :key="index">
                  <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; width: 120px; min-width: 120px; max-width: 120px; padding: 8px 2px; text-align: center; background-color: #fff;">
                    <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="reset(item); dialog.form = true;"
                          
                          v-bind="attrs"
                          v-on="on"

                          min-width="24" min-height="24"
                          x-small
                          rounded
                          color="blue"
                          elevation="0"
                          class="white--text text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon size="15">mdi-square-edit-outline</v-icon>
                        </v-btn>
                      </template>

                      <span>Ubah</span>
                    </v-tooltip>
                    <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          min-width="24" min-height="24"
                          x-small
                          rounded
                          :disabled="item.num_children === 2 ? true : false"
                          @click="dialog.form = true; resetSub(item);"
                          color="green"
                          elevation="0"
                          class="white--text text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon size="15">mdi-plus-circle</v-icon>
                          
                        </v-btn>
                      </template>

                      <span>Tambah</span>
                    </v-tooltip>
                    <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="toDelete(item.id)"

                          v-bind="attrs"
                          v-on="on"

                          min-width="24" min-height="24"
                          x-small
                          :disabled="item.is_child ? true : false"
                          rounded
                          color="red"
                          elevation="0"
                          class="white--text text-capitalize mx-1 px-0"
                          style="font-weight: 600; border-radius: 6px;">
                          <v-icon size="15">mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                      
                      <span>Hapus</span>
                    </v-tooltip>
                  </td>
                  <td class="sticky-col second-col" style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left; width: 100%;" :style="item.num_children === 1 ? 'font-weight: 600; padding-left: 18px;' : item.num_children === 2 ? 'padding-left: 24px;' : ''">
                    <div>
                      <span v-if="item.number !== undefined">{{ item.number }}. </span>{{ item.kriteria }}
                    </div>
                  </td>
                </tr>
              </table>
            </div> -->
            <v-card-text
              v-if="list.length === 0"
              class="pb-0 my-4" style="height: calc( 100vh - 295px ); display: flex; align-items: center; justify-content: center;">
              <div class="text-center">
                <v-img 
                  class="mx-auto"
                  contain
                  alt="vuetify"
                  :width="90"
                  :height="90"
                  :src="require('@/assets/image/empty.png')">
                </v-img>
                <div class="mt-3 fs-16">
                  Belum ada data
                </div>
              </div>
            </v-card-text>
          </div>

          <!-- <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid"
            :height="`calc(100vh - ${pagination.total_data > 0 ? '274px' : '202px'})`"
            :show-select="checkbox"
            :single-select="true"
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="configHeaders"
            :items="list"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick"
            @toggle-select-all="handleToggleAll($event)"
            @dblclick:row="doubleClick"
            hide-default-footer>
            <template
              v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
              v-slot:[`item.${header.value}`]="{ value }">
              {{ rowFormat(header.format, value) }} 
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ lastIndex + index }}
            </template>

            <v-progress-linear 
              v-show="process.load" 
              slot="progress" 
              color="white" 
              indeterminate>
            </v-progress-linear>
          </v-data-table> -->

          <!-- <pagination v-if="pagination.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)" 
            :model="pagination"/> -->
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,
          form: false,
          delete: false,

          map: false
        },
        search: '',
        selected: {
          row: [],
          freeze: [],
          delete: []
        },
        tree: [],
        name_parent: '',
        options: {},
        headers: [],
        list: [],
        pagination: {},
        lastIndex: 0,
        limit: 20,
        is_last: false,

        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },
        markers: [],

        form: {
          id: '',
          number: '',
          kriteria: '',
          par_id: '0',
          bobot_minor: '',
          bobot_mayor: ''
        },
        process: {
          load: false,
          form: false,
          delete: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      }
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value.split('.')[0]
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          },00`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].title)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          // data = value.length > 0 ? moment(value).format(format === 'date' ? 'D MMM, YYYY' : format === 'time' ? 'HH:mm' : 'D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }
        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (non_load) {
        this.process.load = non_load !== undefined ? false : true

        // this.limit = pagination.row

        let params = {
          // limit: pagination.row,
          // page: pagination.page,
          limit: 10000,
          search: this.search
        }

        this.selected.row = []

        await get('kpi_unit/master/data', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Kode',
                width: '150px',
                value: 'code',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama',
                width: '400px',
                value: 'name',
                freeze: false,
                hide: false
              }
            ]
            
            this.list = res.results.data

            // res.results.data.map((item, index_par) => {
            //   this.list.push({
            //     ...item,
            //     num_children: 0,
            //     is_child: item.child.length > 0 ? true : false
            //   })
            //   if(item.child.length > 0){
            //     item.child.map((child, index) => {
            //       if(child.child.length > 0){
            //         this.list.push(
            //           {
            //             ...child,
            //             num_children: 1,
            //             is_child: true
            //           }
            //         )
            //         child.child.map((child2, index2) => {
            //           this.list.push(
            //             {
            //               ...child2,
            //               num_children: 2,
            //               is_child: false
            //             }
            //           )
            //         })
            //       } else {
            //         this.list.push(
            //           {
            //             ...child,
            //             num_children: 1,
            //             is_child: false
            //           }
            //         )
            //       }
            //     }
            //     )
            //   } 
            // })
            // this.pagination = res.results.pagination

            // this.lastIndex = (pagination.page - 1) * pagination.row 
            // this.lastIndex += 1

            // this.addFreezes()

            // this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            // if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: ${this.set_color};
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: ${this.set_color};
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },
      
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item !== undefined ? item.id : '',
          number: item !== undefined ? item.number : '',
          kriteria: item !== undefined ? item.kriteria : '',
          par_id: item !== undefined ? item.par_id : '0',
          bobot_minor: item !== undefined ? item.bobot_minor : 0,
          bobot_mayor: item !== undefined ? item.bobot_mayor : 0
        }

        this.name_parent = item !== undefined ? `${item.kriteria}` : ''

        this.is_last = item !== undefined ? item.child === undefined ? true : false : false

        this.process.form = false

        this.message.error = ''
        
      },
      resetSub (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: '',
          number: '',
          kriteria: '',
          par_id: item.id
        }

        this.name_parent = `${item.kriteria}`

        this.is_last = item !== undefined ? item.par_id !== '0' ? true : false : false

        this.process.form = false

        this.message.error = ''
        
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id.length < 1 ? 'kpi_unit/master/add' : 'kpi_unit/master/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch('non_load')
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post('kpi_unit/master/delete', {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          if (res.status === 200) {
            this.process.delete = false
            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.process.delete = false
            this.message.error = res.message
          }
        })
      },
    }
  }
</script>

<style>
  .table-grid table thead > tr > th, .table-grid table tbody > tr > td {
    position: sticky;
    position: -webkit-sticky;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .table-grid table > tbody > tr > td:nth-child(1) {
    left: 0; 
    z-index: 1;
  }

  .table-grid table > tbody > tr:nth-of-type(even) .text-start, table > tbody > tr:nth-of-type(even) .text-center, table > tbody > tr:nth-of-type(even) .text-end {
    background: #fafafa;
  }

  .table-grid table > tbody > tr:nth-of-type(odd) .text-start, table > tbody > tr:nth-of-type(odd) .text-center, table > tbody > tr:nth-of-type(odd) .text-end {
    background: white;
  }
  
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  width: 100%;
}

tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>